"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _HlsJs = _interopRequireDefault(require("./HlsJs"));
var _HlsJsPlayer = _interopRequireDefault(require("./HlsJsPlayer"));
var _PlayerFactory2 = _interopRequireDefault(require("../models/PlayerFactory"));
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var HlsJsPlayerFactory = exports["default"] = /*#__PURE__*/function (_PlayerFactory) {
  (0, _inherits2["default"])(HlsJsPlayerFactory, _PlayerFactory);
  function HlsJsPlayerFactory(fetchHlsJsLibrary) {
    var _this;
    (0, _classCallCheck2["default"])(this, HlsJsPlayerFactory);
    _this = _callSuper(this, HlsJsPlayerFactory);
    _this.fetchHlsJsLibrary = fetchHlsJsLibrary;
    _this.hlsJsPlayerInstances = 0;
    return _this;
  }
  (0, _createClass2["default"])(HlsJsPlayerFactory, [{
    key: "createPlayer",
    value: function createPlayer() {
      var hlsJsLibrary = new _HlsJs["default"](this.fetchHlsJsLibrary);
      var containerId = 'hlsjs_player_' + this.hlsJsPlayerInstances;
      this.hlsJsPlayerInstances++;
      var containerElement = document.createElement('div');
      containerElement.setAttribute('id', containerId);
      containerElement.setAttribute('style', 'width: 0px; height: 0px; display: none;');
      var videoElement = document.createElement('video');
      containerElement.appendChild(videoElement);
      document.body.appendChild(containerElement);
      return new _HlsJsPlayer["default"](hlsJsLibrary, videoElement, containerId);
    }
  }]);
  return HlsJsPlayerFactory;
}(_PlayerFactory2["default"]);
//# sourceMappingURL=HlsJsPlayerFactory.js.map